import { render, staticRenderFns } from "./coupon-preview.vue?vue&type=template&id=27cf870c&scoped=true&"
import script from "./coupon-preview.vue?vue&type=script&lang=ts&"
export * from "./coupon-preview.vue?vue&type=script&lang=ts&"
import style0 from "./coupon-preview.vue?vue&type=style&index=0&id=27cf870c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf870c",
  null
  
)

export default component.exports